// Отзиви за МИНАЛИ наематели (преди Livupp): излиза веднага след
// регистрация на наемодател/ПМ. Пълни репутационната база от първия ден —
// собствен опит, по телефон + име, със звезди. Може да се добавят няколко
// поред; регистрира ли се човекът, отзивът се закача към акаунта му.

import React, { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { api } from '../../api';
import { showError, showSuccess } from '../../toast';
import { Button, Card, COLORS, Input, Label, Muted, Screen, Title } from '../../ui';
import { t } from '../../i18n';

function Stars({ value, onChange }: { value: number; onChange: (v: number) => void }) {
  return (
    <View style={{ flexDirection: 'row', justifyContent: 'center', gap: 10, marginVertical: 10 }}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Pressable key={i} onPress={() => onChange(i)} hitSlop={6}>
          <Text style={{ fontSize: 34, color: i <= value ? '#F59E0B' : COLORS.border }}>★</Text>
        </Pressable>
      ))}
    </View>
  );
}

export default function PastTenantsScreen({ navigation }: any) {
  const [phone, setPhone] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [saving, setSaving] = useState(false);
  const [added, setAdded] = useState<string[]>([]);

  const submit = async () => {
    setSaving(true);
    try {
      await api('/reviews/past-tenant', {
        body: {
          phone,
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          rating,
          ...(comment.trim() ? { comment: comment.trim() } : {}),
        },
      });
      setAdded((a) => [...a, `${firstName.trim()} ${lastName.trim()} · ${'★'.repeat(rating)}`]);
      setPhone('');
      setFirstName('');
      setLastName('');
      setRating(0);
      setComment('');
      showSuccess(t('Отзивът е записан. Може да добавите още един.'));
    } catch (e: any) {
      showError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Screen>
      <Title>{t('Минали наематели')}</Title>
      <Muted>
        {t('Имали сте наематели преди Livupp? Оставете отзив за тях — така следващият наемодател ще знае какво да очаква, а вашите бъдещи кандидати ще се проверяват в по-пълна база. Отнема минута на човек.')}
      </Muted>

      {added.length > 0 && (
        <Card style={{ borderColor: COLORS.success, borderWidth: 1.5 }}>
          <Label>{t('Добавени сега')}</Label>
          {added.map((a) => (
            <Text key={a} style={{ color: COLORS.text, marginTop: 4 }}>
              ✓ {a}
            </Text>
          ))}
        </Card>
      )}

      <Card>
        <Label>{t('Телефон на наемателя')}</Label>
        <Input value={phone} onChangeText={setPhone} keyboardType="phone-pad" placeholder="+359 88 …" />
        <Label>{t('Име')}</Label>
        <Input value={firstName} onChangeText={setFirstName} placeholder={t('Иван')} />
        <Label>{t('Фамилия')}</Label>
        <Input value={lastName} onChangeText={setLastName} placeholder={t('Иванов')} />
        <Label>{t('Оценка')}</Label>
        <Stars value={rating} onChange={setRating} />
        <Label>{t('Коментар (по избор)')}</Label>
        <Input
          value={comment}
          onChangeText={setComment}
          multiline
          numberOfLines={3}
          placeholder={t('Плащаше навреме, върна имота в добро състояние…')}
          style={{ minHeight: 80, textAlignVertical: 'top' }}
        />
        <Muted>
          {t('Отзивът е ваше лично твърдение за собствен опит и се вижда при проверка на този номер. Пишете само истината — неверни отзиви се премахват при проверка.')}
        </Muted>
        <Button
          title={t('Запази отзива')}
          onPress={submit}
          disabled={phone.trim().length < 6 || !firstName.trim() || !lastName.trim() || rating === 0}
          loading={saving}
        />
        <Button
          title={added.length > 0 ? t('Готово') : t('По-късно')}
          variant="ghost"
          onPress={() => navigation.goBack()}
        />
      </Card>
    </Screen>
  );
}
